import { getFolderIdForSelectedNode } from 'owa-mail-folder-forest-store';
import doesFolderIdEqualName from 'owa-session-store/lib/utils/doesFolderIdEqualName';
import type Item from 'owa-service/lib/contract/Item';

/**
 * Selects the reading-pane copy: selected-folder item, then sent item, then the first available item.
 */
export default function getPreferredConversationItem<T extends Item>(
    items: readonly T[]
): T | undefined {
    const selectedFolderId = getFolderIdForSelectedNode();
    let localItem: T | undefined;
    let sentItem: T | undefined;
    for (const item of items) {
        if (item.ParentFolderId && item.ParentFolderId.Id == selectedFolderId) {
            localItem = item;
        } else if (doesFolderIdEqualName(item.ParentFolderId?.Id || '', 'sentitems')) {
            sentItem = item;
        }
    }
    return localItem ?? sentItem ?? items[0];
}
